export default __webpack_public_path__ + "static/form-grouping-dont-fb6db9ac89aad29d52d0493044dd97933e5258cd0bb1b28a2ccc25cf4d63019f.png";